'use strict';
var React = require('react');
var BaseClassComponent = require('../../shared/base.jsx');
// var EnumCoreModule = require('../../../../src/public/js/enum-core.js');
// var Numeral = require('numeral');
// var Currency = require('currency-symbol-map');
let toastr = require('toastr');

let client = require('../../../../sdk/client');


class StatementComponent extends BaseClassComponent {
    constructor(props) {
        super(props);

        let cfRfcCliente = this.props.user.CustomFields != null ? this.props.user.CustomFields.find(x => x.Code == process.env.CF_RFC_EMPRESA) : undefined;

        if (cfRfcCliente != undefined) {
            cfRfcCliente = cfRfcCliente.Values[0];
        }
        else {
            cfRfcCliente = undefined;
        }

        this.state = {
            saldo: '-',
            porVencer: '-',
            vencidos_1_15: '-',
            vencidos_16_30: '-',
            vencidos_61_plus: '-',
            vencidos_31_60: '-',
            tableData: [],
            displayData: [],
            currentPage: 0,
            currency: "MXN",
            rfcCliente: cfRfcCliente
        }

        this.handleChange = this.handleChange.bind(this);

        this.perPage = 50;
        this.pagePadding = 5;
    }

    handleChange(event) {
        if (event.target.tagName == 'BUTTON') {
            this.setState({
                currency: event.target.value
            })

            if (document.getElementById('delivery-address').value != '') {
                this.getTablesData(document.getElementById('delivery-address').value, event.target.value);
            }
        }

        if (event.target.tagName == 'SELECT') {
            if (event.target.value != '') {
                this.getTablesData(event.target.value, this.state.currency);
            }
        }
    }

    componentDidMount() {
        var addresses = this.props.addresses.filter(x => x.Pickup == true);

        if (addresses.length == 1) {
            document.getElementById("delivery-address").selectedIndex = "1";
            this.getTablesData(addresses[0].ID, this.state.currency);
        }
    }

    getDeliveryAddresses(addresses) {
        var options = addresses.filter(x => x.Pickup == true)
        let items = [];
        options.forEach(element => {
            let text = element.Line2// ? element.Line2 : `${element.Line1} C.P ${element.PostCode} ${element.State} ${element.City}, ${element.Country}`;
            items.push(<option key={element.ID} value={element.ID}>{text}</option>);
        });

        return items;
    }

    getTablesData(addressId, currency) {
        let cfClientId = this.props.user.CustomFields != null ? this.props.user.CustomFields.find(x => x.Name == process.env.NAME_CF_CLIENTE_ID) : undefined;

        if (cfClientId != undefined) {
            if (cfClientId.Values.length > 0 && cfClientId.Values[0].trim().length > 0) {
                this.getUserConfigurationOfWarehouses(addressId, currency, cfClientId.Values[0])
            } else {
                console.log('No hay client ID valido');
            }

        } else {
            console.log('No hay CF de client ID');
        }

    }

    getUserConfigurationOfWarehouses(addressId, currency, liderClientId) {

        const promiseUserConfiguration = new Promise((resolve, reject) => {
            const options = {
                pluginId: process.env.ADMINISTRACION_ALMACENES,
                tableName: "ConfiguracionUsuario",
                query: [{
                    Name: "UserId",
                    Operator: "equal",
                    Value: this.props.user.ID
                },
                {
                    Name: "AddressId",
                    Operator: "equal",
                    Value: addressId
                }
                ]
            };

            client.CustomTables.searchCustomTable(options, function (err, result) {
                resolve(result);
            });
        });

        const promiseSucursales = new Promise((resolve, reject) => {
            const options = {
                pluginId: process.env.ADMINISTRACION_ALMACENES,
                tableName: "Almacenes",
            };

            client.CustomTables.getCustomTableContents(options, function (err, result) {
                resolve(result);
            });
        });

        Promise.all([promiseUserConfiguration, promiseSucursales]).then(responses => {
            let userConfigAddresses = responses[0];
            let warehouses = responses[1];

            if (userConfigAddresses.TotalRecords == 1 && warehouses.TotalRecords > 0) {
                let config = userConfigAddresses.Records[0];

                let branch = warehouses.Records.find(x => x.Nombre == config.AlmacenFacturacion);
                if (branch != undefined) {
                    const requestBody = {
                        "operatingUnitId": 446,
                        "customerId": Number(liderClientId),
                        "branchID": Number(branch.BrachId),
                        "area": "REFACCIONES",
                        "currencyCode": currency
                    };

                    const promiseGetAccountStatus = client.Statements.GetStatements(requestBody);

                    toastr.info('Obteniendo información espere...','Estado de cuenta');

                    promiseGetAccountStatus.then(response => {
                        console.log(response)
                        if (response.Message == "Éxito") {
                            toastr.success('Información cargada con éxito.','Estado de cuenta');

                            this.setState({
                                porVencer: response.ActiveBalance,
                                saldo: response.TotalBalance,
                                vencidos_1_15: response.BalanceDue1_15,
                                vencidos_16_30: response.BalanceDue16_30,
                                vencidos_31_60: response.BalanceDue31_60,
                                vencidos_61_plus: response.BalanceDue61,
                                tableData: response.DocumentsAccountStatus,
                                displayData: response.DocumentsAccountStatus.slice(0, this.perPage)
                            })
                        } else {
                            toastr.warning('Error al obtener los datos de estado de cuenta, inténtelo más tarde. Si el problema persiste consulte al administrador.','Estado de cuenta');

                            this.setState({
                                saldo: '-',
                                porVencer: '-',
                                vencidos_1_15: '-',
                                vencidos_16_30: '-',
                                vencidos_61_plus: '-',
                                vencidos_31_60: '-',
                                tableData: [],
                                displayData: []
                            });
                        }
                    });
                } else {
                    console.log('el branch id no se encuentra');
                }

            } else {
                console.log('No hay configuracion valida para esta address');

            }
        });
    }

    handlePageChange(page) {
        this.setState({
            displayData: this.state.tableData.slice(page * this.perPage, (page + 1) * this.perPage),
            currentPage: page
        })
    }

    handleDownloadClick(companyRFC, clientRFC, invoiceSeries, invoiceNumber, format) {
        document.body.style.cursor = 'wait';
        client.InvoiceRequest.downloadInvoice(companyRFC, clientRFC, invoiceSeries, invoiceNumber, format)
            .then((response) => {
                if (response.Result !== 0) {
                    //alert(response.Message);
                    document.body.style.cursor = 'default';
                    toastr.error("Hubo un error al descargar la factura, favor de intentar de nuevo depues de unos minutos");
                } else {
                    var link = document.createElement('a');
                    if (format === "XML") {
                        link.download = invoiceSeries + invoiceNumber + '.xml';
                        link.href = 'data:application/xml;base64,' + response.file;
                    } else {
                        link.download = invoiceSeries + invoiceNumber + '.pdf';
                        link.href = 'data:application/octet-stream;base64,' + response.file;
                    }
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    document.body.style.cursor = 'default';
                    setTimeout(function () { URL.revokeObjectURL(link.href); }, 1500);
                }
            },
                (error) => {
                    console.log(error);
                });
    }

    renderTopTable(){
        return(
            <div>
                <table className="STT_tabla-saldos hide-on-mobile-tablet">
                    <thead style={{ backgroundColor: "#fff" }}>
                        <tr>
                            <th className="STT_tabla-saldos-cell"></th>
                            <th className="STT_tabla-saldos-cell"></th>
                            <th className="STT_tabla-saldos-cell" colSpan="4">SALDOS VENCIDOS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="STT_tabla-saldos-cell">SALDO</td>
                            <td className="STT_tabla-saldos-cell">POR VENCER</td>
                            <td className="STT_tabla-saldos-cell">1-15</td>
                            <td className="STT_tabla-saldos-cell">16-30</td>
                            <td className="STT_tabla-saldos-cell">31-60</td>
                            <td className="STT_tabla-saldos-cell">61+</td>
                        </tr>
                        <tr>
                            <td className="STT_tabla-saldos-cell">${this.state.saldo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.porVencer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.vencidos_1_15.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.vencidos_16_30.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.vencidos_31_60.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.vencidos_61_plus.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                        </tr>
                    </tbody>
                </table>
                <table className="STT_tabla-saldos hide-on-desktop">
                    <thead style={{ backgroundColor: "#fff" }}>
                        <tr>
                            <th className="STT_tabla-saldos-cell"></th>
                            <th className="STT_tabla-saldos-cell"></th>
                            <th className="STT_tabla-saldos-cell">SALDOS VENCIDOS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="STT_tabla-saldos-cell">SALDO</td>
                            <td className="STT_tabla-saldos-cell">POR VENCER</td>
                            <td className="STT_tabla-saldos-cell">1-15</td>
                        </tr>
                        <tr>
                            <td className="STT_tabla-saldos-cell">${this.state.saldo.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.porVencer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.vencidos_1_15.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                        </tr>
                    </tbody>
                </table>
                <table className="STT_tabla-saldos hide-on-desktop">
                    <thead style={{ backgroundColor: "#fff" }}>
                        <tr>
                            <th className="STT_tabla-saldos-cell" colSpan="3">SALDOS VENCIDOS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="STT_tabla-saldos-cell">16-30</td>
                            <td className="STT_tabla-saldos-cell">31-60</td>
                            <td className="STT_tabla-saldos-cell">61+</td>
                        </tr>
                        <tr>
                            <td className="STT_tabla-saldos-cell">${this.state.vencidos_16_30.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.vencidos_31_60.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                            <td className="STT_tabla-saldos-cell">${this.state.vencidos_61_plus.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        let self = this;

        let tempPages = []
        for (let index = 0; index < self.state.tableData.length / self.perPage; index++) {
            tempPages.push(index)
        }

        return (
            <React.Fragment>

                <div id="Statements" className="tab-pane fade">
                    <h4>Estado de cuenta</h4>

                    <div className="STT_currency-container">
                        <button className={this.state.currency === "MXN" ? "STT_Currency-button-selected" : "STT_Currency-button"} style={{ marginLeft: 0 + 'px' }} onClick={this.handleChange} value="MXN">MXN</button>
                        <button className={this.state.currency === "USD" ? "STT_Currency-button-selected" : "STT_Currency-button"} style={{ marginLeft: 0 + 'px' }} onClick={this.handleChange} value="USD">USD</button>
                    </div>
                    <div className="row" id="container-selector-sucursal-statement">
                        <div className="col-3" style={{ marginBottom: "6vh" }}>

                            <span style={{ textTransform: "none", color: "#808080" }} className="STT_lbl-sucursal title lbl-profile">Sucursal</span>
                            <span>
                                <select name="delivery-address" id="delivery-address" className="STT_select get-text input-address-sec selector-sucursal-statement" data-react-state-name="DeliveryAddress" data-react-state-component-name="DeliveryAddress" onChange={this.handleChange}>
                                    <option key='' value=''>Selecciona una opción</option>
                                    {self.getDeliveryAddresses(this.props.addresses)}
                                </select>
                                {/*<i className="fa fa-angle-down"></i>*/}
                            </span>
                        </div>
                    </div>
                    

                    <div className="">
                        {self.renderTopTable()}
                    </div>

                    <div className="STT_table">
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th><p>Factura</p></th>
                                    <th><p>Saldo</p></th>
                                    <th><p>Fecha de vencimiento </p></th>
                                    <th><p>Monto facturado </p></th>
                                    <th><p>Fecha de factura </p></th>
                                    <th><p>Días vencida </p></th>
                                    <th><p>Descarga de factura </p></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.displayData.map(function (item, key) {
                                        return (<tr key={key}>
                                            <td className="STT_data">{item.InvoiceSeriesNumber}</td>
                                            <td className="STT_data">${item.Balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                            <td className="STT_data">{item.ExpirationDate.split('T')[0]}</td>
                                            <td className="STT_data">${item.OriginalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                                            <td className="STT_data">{item.InvoiceDate.split('T')[0]}</td>
                                            <td className="STT_data">{item.DaysExpired} días</td>
                                            <td className="STT_data"><div>
                                                <a className="btn_delete_act" onClick={() => self.handleDownloadClick("DME870724367", self.state.rfcCliente, item.InvoiceSeriesNumber.split("-")[0], item.InvoiceSeriesNumber.split("-")[1], "XML")/*self.handleDownloadClick("rfcComp","rfcClient",item.InvoiceSeriesNumber.split("-")[0],item.InvoiceSeriesNumber.split("-")[1],"XML")*/}>
                                                    <i className="icon" style={{ backgroundImage: 'url(/assets/images/bepensa/xml_icon.svg)' }}></i>
                                                </a>
                                                <a className="btn_delete_act" onClick={() => self.handleDownloadClick("DME870724367", self.state.rfcCliente, item.InvoiceSeriesNumber.split("-")[0], item.InvoiceSeriesNumber.split("-")[1], "PDF")/*self.handleDownloadClick("rfcComp","rfcClient",item.InvoiceSeriesNumber.split("-")[0],item.InvoiceSeriesNumber.split("-")[1],"PDF")*/}>
                                                    <i className="icon" style={{ backgroundImage: 'url(/assets/images/bepensa/pdf_icon.svg)' }}></i>
                                                </a>
                                            </div></td>
                                        </tr>)
                                    })
                                }
                            </tbody>
                        </table>
                        <div className="STT_PageButtons">
                            {
                                tempPages.map(function (item, index) {
                                    /* CASE-START*/
                                    if (
                                        index === 0 ||
                                        index === (tempPages.length - 1) ||
                                        (
                                            index >= (self.state.currentPage - self.pagePadding) &&
                                            index <= (self.state.currentPage + self.pagePadding)
                                        )
                                    ) {
                                        return (
                                            <div
                                                className={self.state.currentPage === index ? "STT_Selected STT_PageButton" : "STT_PageButton"}
                                                key={index}
                                                onClick={() => self.handlePageChange(index)}>
                                                {index + 1}
                                            </div>
                                        )
                                    } else if (
                                        index === self.state.currentPage - self.pagePadding - 1 ||
                                        index === self.state.currentPage + self.pagePadding + 1
                                    ) {
                                        return (
                                            <div
                                                className="STT_PageButton"
                                                key={index}
                                            >
                                                {"..."}
                                            </div>
                                        )
                                    } else {
                                        return null;
                                    }
                                    /* CASE-END*/
                                }, this)
                            }
                        </div>
                    </div>
                    <div className="settings-button">
                        <div className="btn-previous pull-left btn-secc-profile" onClick={(e) => { $('.nav-pills a:first').tab('show'); }}>Regresar</div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

module.exports = StatementComponent;